module.exports = __webpack_public_path__ + "img/next-steps.24ddd0e8.svg";